import app from '@/app';
import { GrowthRateResourceClient } from '../../pavrunner-api';
import templateUrl from './budget-limits-search.html';

/* @ngInject */
function Controller($controller, BudgetLimit, Principal) {
	
  var $ctrl = this;

  $ctrl.currentAccount = null;
  
  Principal.identity().then(account => {
		$ctrl.currentAccount = account;
	});
  
  $controller('AbstractEntitySearchController', {
		$ctrl: this,
		resource: BudgetLimit,
		type: 'budgetLimit'
	});

}

const component = {
	templateUrl,
	controller: Controller,
	bindings: {
		$transition$: '<'
	}
};

app.component('budgetLimitsSearch', component);